import { render } from "./Filled.vue?vue&type=template&id=27bd4d37"
const script = {}

import "./Filled.vue?vue&type=style&index=0&id=27bd4d37&lang=scss"
script.render = render

export default script